/**
 * SectionLabel — editorial eyebrow used at the top of every major section.
 * Example: <SectionLabel number="01" label="WHAT WE DO" />
 */
export default function SectionLabel({ number, label, align = "left" }) {
    return (
        <div
            // Guard the trailing conditional so we never emit "class-name "
            // (trailing space). Newer Chromium versions preserve the trailing
            // space in the DOM attribute while older ones strip it, causing a
            // hydration mismatch after react-snap prerender.
            className={
                "flex items-center gap-4" +
                (align === "center" ? " justify-center" : "")
            }
            data-testid={`section-label-${number}`}
        >
            <span className="eyebrow">{number}</span>
            <span
                aria-hidden="true"
                className="h-px w-10 bg-[#C9A86A]/40"
            />
            <span className="eyebrow">{label}</span>
        </div>
    );
}
